// extracted by mini-css-extract-plugin
export default {"logout":"style_logout__b5EUj","adminTabs":"style_adminTabs__xmECc","active":"style_active__QVbt0"};